export const PartnerType = {
  PRIVATE: 'PRIVATE',
  BUSINESS: 'BUSINESS',
  ENTREPRENEUR: 'ENTREPRENEUR',
}
